import React, { useState } from "react";
import { AlertConfig } from "model/alerting";
import ApiCaller from "api/apiCaller";
import "./index.css";
import { ToggleButton } from "components/ToggleButton";

interface AlertItemProps {
  alertData: AlertConfig;
}

export default function AlertItem({alertData}: AlertItemProps) {
  const baseRoute = 'monitoring/alerting';
  const [alertActiveStatus, setAlertActiveStatus] = useState(alertData.is_active);

  const handleActiveStatusSwitchChange = (nextChecked: boolean) => {
    setAlertActiveStatus(nextChecked);
    const res:any = ApiCaller.put(
      `${baseRoute}/${alertData.id}/active_status?company_id=${alertData.company_id}`,
      {'active_status': nextChecked}
    );
  };

  return (
    <tr className="alerting-item">
      <td>
        <a href={`/monitoring/alerting/view/${alertData?.id}`}>
          <span className="alerting-item__name">{alertData?.name}</span>
        </a>
        <br/>
        <span className="alerting-item__label">{alertData?.created_by}</span>
      </td>
      <td className="alerting-item__info">{alertData?.schedule_time}</td>
      <td className="alerting-item__info">{alertData?.changed_by}</td>
      <td className="alerting-item__info">{alertData?.changed_on}</td>
      <td className="alerting-item__switch">
        <ToggleButton
          className="alert-active__switch"
          handleSwitchChange={handleActiveStatusSwitchChange}
          checked={alertActiveStatus}
        />
      </td>
    </tr>
  );
}
